const { render, useState, useEffect } = wp.element;

const ContactFull = ({ pieceID }) => {
    const [piece, setPiece] = useState()
    const [tab, setTab] = useState('index')

    const [formResponses, setFormResponse] = useState({
        "contact_name": '',
        "contact_email": '',
        "contact_phone_number": '',
        "contact_message": '',
    })

    useEffect(() => {
        if (pieceID) {
            fetch(rest.pieces + "/" + pieceID)
                .then(response => response.json())
                .then(data => { setPiece(data); console.log({ data }) })
        }
    }, [pieceID])

    const changeHandler = e => {
        setFormResponse({ ...formResponses, [e.target.name]: e.target.value })
    }

    return (
        <div className="contact-form__wrapper contact-form--full">

            {tab === "index" ? <IndexTab pieceID={pieceID} piece={piece} setPiece={setPiece} setTab={setTab} changeHandler={changeHandler} formResponses={formResponses} /> : ""}
            {tab === "search" ? <SearchTab setTab={setTab} piece={piece} setPiece={setPiece} /> : ""}

        </div>
    );
};


const IndexTab = ({ pieceID, piece, setPiece, setTab, changeHandler, formResponses }) => {
    const [openSearchBar, setOpenSearchBar] = useState(piece ? true : false)
    return (
        <form className="contact-form" action="/wp-json/cundiff/v1/contact/submit"
            method="post">
            <input onChange={changeHandler} type="text" placeholder="Name" name="contact_name" value={formResponses ? formResponses["contact_name"] : null} />
            <input onChange={changeHandler} type="email" placeholder="Email" name="contact_email" value={formResponses ? formResponses["contact_email"] : null} />
            <input onChange={changeHandler} type="phone" placeholder="Phone Number" name="contact_phone_number" value={formResponses ? formResponses["contact_phone_number"] : null} />
            <div className="specific-piece-toggle"><input type="checkbox" onClick={() => {
                if (openSearchBar && piece) { setPiece(null) } setOpenSearchBar(!openSearchBar)
            }} checked={piece || openSearchBar ? "checked" : ""} /> <label onClick={() => { setOpenSearchBar(!openSearchBar) }}>I have questions about a specific piece.</label>
            </div>
            {openSearchBar && !piece && <SearchBar setTab={setTab} />}
            {piece && <div className="contact-form--piece" onClick={() => {
                setPiece(null); setTab('search')
            }}>
                <div className="image-wrapper">{piece.thumb && <img src={piece.thumb[0]} />}</div>
                {piece.title && <h5 className="piece__title">{piece.title.rendered}</h5>}
                {piece.price && <h6 className={"piece__price" + (piece.price === "Sold" ? " sold" : "")}>{(piece.price === "Sold" ? piece.price : "$" + piece.price)}</h6>}
                <input type="hidden" value={piece.id} name="contact_piece_id" />
            </div>}
            <textarea placeholder="Your Message" required onChange={changeHandler} name="contact_message" id="message">{formResponses.contact_message}</textarea>
            <button className="button button--full" type="submit">Submit Purchase Inquiry</button>
        </form>
    )
}

const SearchBar = ({ setTab, query, setQuery }) => {
    return (
        <input autoFocus onFocus={() => { setTab('search') }} onChange={(e) => { setQuery(e.target.value) }} value={query} type="text" id="search-bar" placeholder="Search By Piece Title" />
    )
}

const SearchTab = ({ setTab, setPiece }) => {
    const [categories, setCategories] = useState([])
    const [selectedCategory, setSelectedCategory] = useState();
    const [selectedMaterial, setSelectedMaterial] = useState();
    const [searchTitle, setSearchTitle] = useState();
    const [products, setProducts] = useState([]);
    const [materials, setMaterials] = useState([])
    const [loading, setLoading] = useState([])
    const [query, setQuery] = useState('');

    // On Load
    useEffect(() => {
        setLoading(true);
        fetch(rest.materials)
            .then(response => response.json())
            .then(data => {
                setMaterials(data)
                console.log({ data })
            })

        fetch(rest.categories).then(response => response.json())
            .then(data => { setCategories(data); setLoading(false) })
    }, [])

    // Category Change
    useEffect(() => {
        setLoading(true);
        setProducts(null);
        if (selectedCategory != null) {
            fetch(rest.pieces + "?pieces_categories=" + selectedCategory)
                .then(response => response.json())
                .then(data => { console.log({ category: data }); setProducts(data); setLoading(false); })
        }
        if (selectedMaterial != null) {
            fetch(rest.pieces + "?pieces_materials=" + selectedMaterial)
                .then(response => response.json())
                .then(data => { console.log({ material: data }); setProducts(data); setLoading(false); })
        }

        if (selectedMaterial === null && selectedCategory === null) {
            setLoading(false);
        }
    }, [selectedCategory, selectedMaterial])

    useEffect(() => {
        if (query) {

            setLoading(true)
            setProducts(null)

            fetch(rest.pieces + "/?search=" + encodeURIComponent(query)).then(response => response.json())
                .then(data => {
                    console.log({ search: data })
                    setProducts(data)
                    setSearchTitle("Searching for " + query);
                    setLoading(false)

                })
        }

    }, [query])

    const categorySelect = (catID) => {
        setSelectedCategory(catID)
    }

    let categoriesMap = categories.map((cat, i) => {
        return <li className="contact-form--category" style={{ order: -cat.count }} key={i} >
            <button onClick={() => { setSelectedMaterial(null); setSearchTitle(cat.name); categorySelect(cat.id) }}>
                <div className="image-wrapper"><img src={cat.thumb && cat.thumb[0] || ""} /></div>
                <span>{cat.name}<small>({cat.count})</small></span>
            </button>
        </li>
    })

    let materialsMap = materials.map((cat, i) => {
        return <li className="contact-form--category" style={{ order: -cat.count }} key={i} >
            <button onClick={() => { setSelectedCategory(null); setSearchTitle(cat.name); setSelectedMaterial(cat.id) }}>
                <div className="image-wrapper"><img src={cat.thumb && cat.thumb[0] || ""} /></div>
                <span>{cat.name} <small>({cat.count})</small></span>
            </button>
        </li>
    })

    let productMap = (products && products[0] ? products.map((piece, i) => {
        return (piece && <li key={i} className="contact-form--piece">
            <button onClick={(e) => { e.preventDefault(); setPiece(piece); setTab('index') }} >
                <div className="image-wrapper"><img src={piece.thumb && piece.thumb[0] || ""} /></div>
                {piece.title && <h5 className="piece__title">{piece.title.rendered || piece.title}</h5>}
                {piece.price && <h6 className={"piece__price" + (piece.price === "Sold" ? " sold" : "")}>{(piece.price === "Sold" ? piece.price : "$" + piece.price)}</h6>}
            </button>
        </li>)
    }) : false)
    return (
        <form className="contact-form">
            <div className="contact-form__header">
                <button onClick={((selectedCategory || selectedMaterial) ? (e) => { e.preventDefault(); setSelectedMaterial(null); setSelectedCategory(null) } : (e) => { e.preventDefault(); setTab('index') })}>X</button>
            </div>
            <h5 className="all-columns no-top-margin">Search By Piece Title:</h5>
            <SearchBar setTab={setTab} query={query} setQuery={setQuery} />
            {!selectedCategory && !selectedMaterial && !query && <>
                <h5 className="all-columns">Or Browse By Category:</h5>
                <ul className="searchList">
                    {!loading && categoriesMap}
                    {!loading && materialsMap}
                    {loading && "Loading"}
                </ul>
            </>}
            {(selectedCategory || selectedMaterial || query) && <>
                <h5 className="all-columns">{searchTitle}</h5>
                <ul className="searchList">
                    {productMap ? productMap : (loading ? <span className="all-columns">Loading</span> : <span className="all-columns">No Results Found</span>)}
                </ul>
            </>}
        </form>
    )
}


export default function () {
    var form = document.getElementById(`contact_form-full`)
    if (form) {
        render(<ContactFull pieceID={form.dataset.piece} />, form);
    }
}